import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useFieldValue } from "formik";
import * as Yup from "yup";
import { useScopes } from "../hooks/useScopes";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { InitialRequestConfig } from "../models/flexible/initial-request";
import { combinePaths } from "../models/flexible/utils";
import { Brand, Preparation } from "../models/generated/graphql";
import { getScopeTreatments } from "../utils/agreement-utils";
import { getPathPrefix } from "../utils/get-path-prefix";
import { GeneralFieldController } from "./general-field-controller";
import { GET_SCOPES, whereDrugs } from "./queries";

export class PackSizeFieldController extends GeneralFieldController {
	getInitialRequestComponents?(): InitialRequestConfig {
		return {
			queries: [GET_SCOPES],
			variables: { where: whereDrugs(this.parent.context.entityType.id, this.parent.context.tenantId) },
		};
	}

	override useControlProps(path: string): FlexControlProps {
		const { selectedScopes } = useScopes(this.parent.context);
		const [recordPreparation] = useFieldValue(combinePaths(getPathPrefix(path, 1), AttributeIdentifiers.TreatmentPack));
		const [brand] = useFieldValue(AttributeIdentifiers.BrandName) as Array<Brand>;
		const isPreparationMatched = (preparation: Preparation) =>
			brand ? preparation.BrandName === brand.Name : preparation.id === recordPreparation?.id;
		const relevantTreatments = selectedScopes
			.flatMap((scope) => getScopeTreatments(scope))
			.filter((treatment) => isPreparationMatched(treatment.regulatedBy));

		return {
			controlType: "typeahead",
			property: "Code",
			optionLabel: "Name",
			disabled: !recordPreparation,
			options: relevantTreatments,
		};
	}

	override getValueTypeProps() {
		return {
			controlType: "typeahead",
			property: "Name",
		};
	}

	protected override createFieldValidationRuleByDataType(): Yup.AnySchema {
		return Yup.object().nullable().required();
	}
}
